import Login from "pages/login/Login";
import { Logout } from "pages/logout/Logout";
import { Password } from "pages/password/Password";
import { SignUp } from "pages/signup/SignUp";
import { Terms } from "pages/terms/Terms";
import { Verification } from "pages/verification/Verification";
import { TRoutes } from "types/commonTypes";

export const routes: TRoutes[] = [
  {
    name: "LOGIN",
    path: "/login",
    component: Login,
  },
  {
    name: "LOGOUT",
    path: "/logout",
    component: Logout,
  },
  {
    name: "SIGN_UP",
    path: "/signup",
    component: SignUp,
  },
  {
    name: "PASSWORD",
    path: "/find-password",
    component: Password,
  },
  {
    name: "VERIFICATION",
    path: "/verification",
    component: Verification,
  },
  {
    name: "TERMS",
    path: "/terms",
    component: Terms,
  },
];
